<template>
  <Category cate-name="health" category-name="健康" />
</template>

<script>
import Category from '@/components/Category.vue'
export default {
  components: {
    Category
  }
}
</script>

<style scoped></style>
